export default {
  namespaced: true,
  getters: {
    productRegistrations: (state, getters, rootState) => rootState.productRegistrations.filter(obj => obj.kind === 'bestove'),
    supportRequests: (state, getters, rootState) => {
      let sr = rootState.productRegistrations.filter(obj => obj.kind === 'bestove').map(pr => {
        return pr.support_requests
      })
      return _.orderBy(_.flatten(sr), 'id', 'desc')
    },
    productReviews: (state, getters, rootState) => rootState.reviews.product_reviews.filter(obj => obj.kind === 'bestove'),
    supportReviews: (state, getters, rootState) => rootState.reviews.support_reviews.filter(obj => obj.kind === 'bestove'),
    interventions: (state, getters, rootState) => {
      return {
        running: rootState.interventions.running.filter(obj => obj.kind === 'bestove'),
        realized: rootState.interventions.realized.filter(obj => obj.kind === 'bestove'),
        resolved: rootState.interventions.resolved.filter(obj => obj.kind === 'bestove')
      }
    },
    allInterventions: (state, getters) => {
      return getters.interventions.running.concat(getters.interventions.realized).concat(getters.interventions.resolved)
    }
  }
}
